import { DeleteIcon, IconButton, makeStyles } from '@freighthub/silhouette-core'
import { FC } from 'react'
import { useI18n } from 'utils/localisation'

const useStyles = makeStyles(() => ({
  button: { width: '100%', minWidth: 'auto' },
}))

type DeleteCargoRowProps = {
  deleteCargo: (() => void) | null
}

export const DeleteRow: FC<DeleteCargoRowProps> = ({ deleteCargo }) => {
  const { translate } = useI18n()
  const classes = useStyles()

  const handleOnClick = () => {
    if (deleteCargo != null) {
      deleteCargo()
    }
  }

  return (
    <IconButton
      onClick={handleOnClick}
      className={classes.button}
      disabled={!deleteCargo}
      aria-label={translate('quote_request-cargo_delete')}
    >
      <DeleteIcon />
    </IconButton>
  )
}
